import { truncateValue, truncationSize } from '../../utils';
import { DataDomeRequest } from '../api';
import { User } from '../user';
import { ActionType, DataDomeEvent, EventParams } from './event';

/**
 * Status of the password update event.
 */
export type PasswordUpdateStatus = 'attempted' | 'failed' | 'succeeded' | 'linkExpired';

/**
 * Reason for the password update event.
 */
export type PasswordUpdateReason = 'forcedReset' | 'forgotPassword' | 'userUpdate';

/**
 * This interface defines the parameters for the password update event.
 */
export interface PasswordUpdateEventParams extends Omit<EventParams, 'action'> {
    reason: PasswordUpdateReason;
    status: PasswordUpdateStatus;
    user: Pick<User, 'id'>;
}

/**
 * This class is used to define the password update event.
 */
export class PasswordUpdateEvent extends DataDomeEvent {
    reason: PasswordUpdateReason;
    status: PasswordUpdateStatus;
    user: Pick<User, 'id'>;
    constructor({
        account,
        authentication,
        reason,
        session,
        status,
        user,
    }: PasswordUpdateEventParams) {
        super({
            action: ActionType.PASSWORD_UPDATE,
            account,
            authentication,
            session,
        });
        this.reason = reason;
        this.status = status;
        this.user = {
            id: truncateValue(user.id, truncationSize('UserId')),
        };
    }

    override mergeWith(requestData: DataDomeRequest): DataDomeRequest {
        super.mergeWith(requestData);
        requestData.reason = this.reason;
        requestData.status = this.status;
        requestData.user = this.user;
        return requestData;
    }
}
